<template>
    <form class="col-md-8 mx-auto" @submit.prevent="onSubmit">
        <div class="loader" v-if="loading"></div>
        <div v-if="!loading">
            <div class="btn-group" role="group" aria-label="Basic example">
                <button type="button"
                        class="btn btn-primary"
                        @click="backToList">
                    <i class="fas fa-th-list"></i> {{ $t('backToList') }}
                </button>
            </div>
            <page-title :title="$t('notificationConfig.title')"></page-title>
            <div class="card row">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('notificationConfig.config') }}</div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="form-group col-12">
                            <label :for="'notificationType' + _uid" class="font-weight-bold required">{{ $t('notificationConfig.type') }}</label>
                            <input type="text"
                                   class="form-control"
                                   readonly
                                   :id="'eventType' + _uid"
                                   :name="'eventType' + _uid"
                                   v-model="notificationConfig.notificationType"
                                   :data-vv-as="$t('notificationConfig.type')" />
                            <span class="text-danger" v-if="errors.has('notificationType' + _uid)">{{ errors.first('notificationType' + _uid) }}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-12">
                            <label :for="'subject' + _uid" class="font-weight-bold required">{{ $t('notificationConfig.subject') }}</label>
                            <input type="text"
                                   class="form-control"
                                   readonly
                                   :id="'subject' + _uid"
                                   :name="'subject' + _uid"
                                   v-model="notificationConfig.messageSubject"
                                   :data-vv-as="$t('notificationConfig.subject')" />
                            <span class="text-danger" v-if="errors.has('subject' + _uid)">{{ errors.first('subject' + _uid) }}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-12">
                            <label :for="'content' + _uid" class="font-weight-bold required">{{ $t('notificationConfig.content') }}</label>
                            <div class="readonly editorContent" v-html="notificationConfig.messageContent"></div>
                            <span class="text-danger" v-if="errors.has('content' + _uid)">{{ errors.first('content' + _uid) }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>
<script>
    import { NotificationConfig } from '../../../models/models';
    import PageTitle from '../../../components/common/PageTitle';
    export default {
        components: {
            PageTitle,
        },
        data() {
            return {
                id: null,
                notificationConfig: new NotificationConfig(),
                loading: false
            }
        },
        methods: {
            backToList() {
                this.$router.push('/administration/notifications');
            },
            loadData() {
                this.loading = true;
                this.$http.get(`/api/notificationConfig/${this.id}`).then(result => {
                    this.notificationConfig = new NotificationConfig(result.data);
                    this.loading = false;
                }).catch(error => {
                    // TODO: Notify
                    this.loading = false;
                });
            }
        },
        mounted() {
            this.id = this.$route.params.id;
            if (this.id) {
                this.loadData();
            }
        }
    }
</script>
<style scoped>
    .readonly{
            background-color: #e9ecef;
            opacity: 1;
            border: 1px solid rgba(0,0,0,.12);
    }

    div .editorContent {
        /*line-height: 1px;*/
        padding: 5px;
    }
</style>
